module.exports = __webpack_public_path__ + "81ca34087b7e1ac42a514500ddd79210.svg";